import * as actionTypes from './setsActionTypes';
import * as wsActionTypes from './workspacesActionTypes';
import piction from '../utils/piction';
import * as constants from '../constants/workspaces';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';
import appConfig from '../appConfig';
import _ from 'lodash';

export const cancelAllRequests = () => ({
  type: actionTypes.SETS_CANCEL_ALL_REQUESTS,
});

export const cancelCreateRequest = (workspaceName, workspaceParentID = '0') => ({
  type: actionTypes.SETS_CANCEL_CREATE_REQUEST,
  workspaceName,
  workspaceParentID,
});

export const createWorkspaceRequest = (
  workspaceName, workspaceParentID, workspaceDescription, requestPromise
) => ({
  type: actionTypes.SETS_CREATE_REQUEST,
  workspaceName,
  workspaceParentID,
  workspaceDescription,
  requestPromise,
});

export const createWorkspaceSuccess = (
  workspaceID, workspaceName, workspaceParentID, workspaceDescription
) => ({
  type: actionTypes.SETS_CREATE_SUCCESS,
  workspaceID,
  workspaceName,
  workspaceParentID,
  workspaceDescription,
});

export const createWorkspaceFailure = (workspaceName, workspaceParentID, err) => ({
  type: actionTypes.SETS_CREATE_FAILURE,
  workspaceName,
  workspaceParentID,
  err,
});

export const createSet = (workspaceName, workspaceParentID = '0', workspaceDescription = '') =>
  function createWorkspacesDispatch(dispatch, getState) {
    const store = getState().workspaces;

    const foundRequestIndex = store.get('createRequests').findKey(createRequest =>
      createRequest.get('workspaceName') === workspaceName &&
      createRequest.get('workspaceParentID') === workspaceParentID
    );

    if (foundRequestIndex !== undefined &&
      !(store.getIn(['createRequests', foundRequestIndex, 'request']) instanceof Error)
    ) {
      return Promise.resolve(new Error('Request with same details already being made'));
    }

    const promise = piction.createLightbox(workspaceName,
      { PARENTID: workspaceParentID, DESCRIPTION: workspaceDescription, ACCESS: 'SET' }
    )
      .then((res) => {
        dispatch(
          createWorkspaceSuccess(res.id, workspaceName, workspaceParentID, workspaceDescription)
        );
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(createWorkspaceFailure(workspaceName, workspaceParentID, err));
        }
        return err;
      });

    dispatch(
      createWorkspaceRequest(workspaceName, workspaceParentID, workspaceDescription, promise)
    );
    return promise;
  };

export const deleteWorkspaceRequest = (workspaceID, requestPromise) => ({
  type: actionTypes.SETS_DELETE_REQUEST,
  workspaceID,
  requestPromise,
});

export const deleteWorkspaceSuccess = workspaceID => ({
  type: actionTypes.SETS_DELETE_SUCCESS,
  workspaceID,
});

export const deleteWorkspaceFailure = (workspaceID, err) => ({
  type: actionTypes.SETS_DELETE_FAILURE,
  workspaceID,
  err,
});

export const deleteSet = workspaceID => function deleteWorkspaceDispatch(dispatch) {
  const promise = piction.deleteLightbox(workspaceID)
    .then((res) => {
      dispatch(deleteWorkspaceSuccess(workspaceID, res.res.ct));
      return res;
    })
    .catch((err) => {
      if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
        dispatch(sessionExpired(err));
      } else {
        dispatch(deleteWorkspaceFailure(workspaceID, err));
      }
      return err;
    });

  dispatch(deleteWorkspaceRequest(workspaceID, promise));
  return promise;
};

export const editWorkspaceRequest = (workspaceID, workspaceName, workspaceDescription, requestPromise) => ({
  type: actionTypes.SETS_EDIT_REQUEST,
  workspaceID,
  workspaceName,
  workspaceDescription,
  requestPromise,
});

export const editWorkspaceSuccess = (workspaceID, workspaceName, workspaceDescription) => ({
  type: actionTypes.SETS_EDIT_SUCCESS,
  workspaceID,
  workspaceName,
  workspaceDescription,
});

export const editWorkspaceFailure = (workspaceID, err) => ({
  type: actionTypes.SETS_EDIT_FAILURE,
  workspaceID,
  err,
});

export const editSet = (workspaceID, workspaceName, workspaceDescription, workspaceUsers, workspaceRemoveUsers) =>
  function retrieveWorkspacesDispatch(dispatch) {
    const options = {
      NAME: workspaceName,
      DESCRIPTION: workspaceDescription,
      MAP_ROLE: 'TRUE',
      MAP_PROFILE: workspaceUsers,
      REMOVE_PROFILE: workspaceRemoveUsers,
      ACCESS: 'SET',
    };
    const promise = piction.editLightbox(workspaceID, options)
      .then((res) => {
        dispatch(editWorkspaceSuccess(workspaceID, workspaceName, workspaceDescription));
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(editWorkspaceFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(editWorkspaceRequest(workspaceID, workspaceName, workspaceDescription, promise));
    return promise;
  };

export const retrieveSetsRequest = requestPromise => ({
  type: actionTypes.SETS_RETRIEVE_REQUEST,
  requestPromise,
});

export const retrieveSetsSuccess = setsList => ({
  type: actionTypes.SETS_RETRIEVE_SUCCESS,
  setsList,
});

export const retrieveSetsFailure = err => ({
  type: actionTypes.SETS_RETRIEVE_FAILURE,
  err,
});

export const retrieveSets = () => function retrieveSetsDispatch(dispatch) {
  const setOptions = {
    // CATEGORY_ID: 0,
    TYPE: 'S',
    PREVIEWS_ON: 'SET',
    PREVIEWS_MAX: 1,
    // PREVIEWS_SORT
    PREVIEWS_URL: 'THUMBNAIL', // DEFAULT: thumbnail
    // PREVIEWS_METATAGS: [TAG1,TAG2],
  };
  const promise = piction.getLightboxes(null, setOptions)
    .then((res) => {
      dispatch(retrieveSetsSuccess(res.res.ct));
      return res;
    })
    .catch((err) => {
      if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
        dispatch(sessionExpired(err));
      } else {
        dispatch(retrieveSetsFailure(err));
      }
      return err;
    });

  dispatch(retrieveSetsRequest(promise));
  return promise;
};

export const clearPanelTreeList = categoryID => ({
  type: actionTypes.SET_LIST_CLEAR,
  categoryID,
});

export const highlightsSetSelected = setID => ({
  type: actionTypes.SET_SELECTED_SUCCESS,
  setID,
});

export const retrieveWorkspaceInfoRequest = (workspaceID, requestPromise) => ({
  type: wsActionTypes.WORKSPACES_RETRIEVE_INFO_REQUEST,
  workspaceID,
  requestPromise,
});

export const retrieveWorkspaceInfoSuccess = (workspaceID, workspaceUsers) => ({
  type: wsActionTypes.WORKSPACES_RETRIEVE_INFO_SUCCESS,
  workspaceID,
  workspaceUsers,
});

export const retrieveWorkspaceInfoFailure = (workspaceID, err) => ({
  type: wsActionTypes.WORKSPACES_RETRIEVE_INFO_FAILURE,
  workspaceID,
  err,
});

export const retrieveSetsInfo = workspaceID =>
  function retrieveSetsInfoDispatch(dispatch) {
    const promise = piction.request('Lightbox_Edit', { CATEGORY_ID: workspaceID, VIEW_ROLE: 'TRUE' }, null)
      .then((res) => {
        if (res && res.a) {
          let users = res.a.user || [];
          users = _.isArray(users) ? users : users.toArray();
          dispatch(retrieveWorkspaceInfoSuccess(workspaceID, users));
          return users;
        } else if ((res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) ||
          (res.RETURN_MESSAGE && res.RETURN_MESSAGE.includes(SESSION_EXPIRED_MESSAGE))) {
          dispatch(sessionExpired(res));
        }
        return res;
      })
      .catch((err) => {
        if ((err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) ||
          (err.RETURN_MESSAGE && err.RETURN_MESSAGE.includes(SESSION_EXPIRED_MESSAGE))) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(retrieveWorkspaceInfoFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(retrieveWorkspaceInfoRequest(workspaceID, promise));
    return promise;
  };
